import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Calendar, UtensilsCrossed, Heart, User, Tag } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

export function BottomNav() {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    
    // Navigation items based on auth state
    // Note: Shopper-specific nav removed - all members use resident experience
    const getNavItems = () => {
        if (!isAuthenticated) {
            return [
                { path: '/', icon: Home, label: 'Home' },
                { path: '/events', icon: Calendar, label: "Events" },
                { path: '/offers', icon: Tag, label: 'Offers' },
                { path: '/about', icon: Heart, label: 'About' },
                { path: '/login', icon: User, label: 'Sign In' },
            ];
        }
        
        // Resident navigation (used by all authenticated members)
        return [
            { path: '/home', icon: Home, label: 'Home' },
            { path: '/events', icon: Calendar, label: 'Events' },
            { path: '/dining', icon: UtensilsCrossed, label: 'Dining' },
            { path: '/wellness', icon: Heart, label: 'Wellness' },
            { path: '/member', icon: User, label: 'Profile' },
        ];
    };
    
    const navItems = getNavItems();

    // Don't show nav on landing page when not authenticated
    if (!isAuthenticated && location.pathname === '/') {
        return null;
    }

    return (
        <nav className="bottom-nav" data-testid="bottom-nav">
            <div className="flex justify-around items-center h-16 max-w-lg mx-auto">
                {navItems.map((item) => (
                    <NavLink
                        key={item.path}
                        to={item.path}
                        end={item.path === '/' || item.path === '/home'}
                        className={({ isActive }) =>
                            `nav-item ${isActive ? 'active' : ''}`
                        }
                        data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, '-')}`}
                    >
                        <item.icon className="w-6 h-6" strokeWidth={2} />
                        <span className="text-xs font-medium">{item.label}</span>
                    </NavLink>
                ))}
            </div>
        </nav>
    );
}

export default BottomNav;
